import React, { useEffect, useRef, useState } from 'react';
import { IonModal, IonHeader, IonToolbar, IonTitle, IonContent, IonButton, IonToast, IonIcon, IonCard, IonCardHeader, IonCardContent, IonInput, IonLabel, IonAlert } from '@ionic/react';
import { dict2blob, downloadBlob, generateQRCode } from '../../foo/converter';
import { _LIMIT_CHARS_URL_SHARE, _NEW_LINE, _cardFontSizeMax, _cardFontSizeMin, _cardWidthMax, _cardWidthMin, _defaultButtonColor, _defaultPurpleButtonColor, _dict, _host, _pathSeparator } from '../constants';
import { useGlobalStore } from '../stateManagement/globalZustand';
import { copyToClipboard } from '../../foo/browser';
import { link, logoWhatsapp, download, closeCircle } from 'ionicons/icons';
import { useUIStore } from '../stateManagement/UIZustand';
import { nodesToUniqueStrings } from '../foo';
import { cutTree, filterDict, replaceKeyPrefixes } from '../../foo/tree';
import { useTreeStore } from '../stateManagement/treeZustand';
import { logMe } from '../../foo/user';

import { useURLStore } from '../stateManagement/URLZustand';
import './ShareModal.css';
import { label2LabelToShow } from '../../foo/cards';
import { exportPDF } from '../../foo/artistic';

interface ShareModalProps {
  data: string;
}

const ShareModal: React.FC<ShareModalProps> = ({ data }) => {
  const [qrCodeURL, setQrCodeURL] = useState<string>('');
  const [linkURL, setLinkURL] = useState<string>('');
  const { lang } = useGlobalStore();
  const { isShareModalOpen, setIsShareModalOpen } = useUIStore();
  const { nodes, l2Audio, l2Image, l2Visibility, path2Params, defaultParams } = useTreeStore();
  const inputFilename = useRef<HTMLIonInputElement>(null);
  const inputFilenamePDF = useRef<HTMLIonInputElement>(null);
  const { URLVars, getURLTo, visibleLabels } = useURLStore();
  const [exporting, setExporting] = useState(false);
  const [waitTime, setWaitTime] = useState(0);
  const [showPDFAlert, setShowPDFAlert] = useState(false);

  const capitalizeText = path2Params[URLVars.nodePath!]?.capitalizeText || defaultParams.capitalizeText;


  useEffect(() => {
    if (data.length > _LIMIT_CHARS_URL_SHARE) {
      return;
    }

    let link = getURLTo().URLImport(data);
    generateQRCode(link)
      .then((url) => {
        setQrCodeURL(url);
        setLinkURL(link);
      })
      .catch((error) => {
        console.error('Error generating QR Code: ', error);
      });
  }, [data]);

  /*useEffect(() => {
    const doExport = async () => {
      if(exporting === true && waitTime > 0){
        await handlePDFExport();
      }
    }

    const timer = setTimeout(() => {
      doExport();
    }, 1000); // Wait for 1 second
    
    return () => clearTimeout(timer);
    
  }, [exporting]);*/

  const baseBtnStyle = {
    height: "60px",
    fontSize: "20px",

  }

  const centeredIonCardStyle = {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
    textAlign: "center",
    margin: "auto",
    marginBottom: "5px"
  }


  const handleExport = () => {
    // add pathFromURL as prefix to labels in data
    const labels = decodeURIComponent(data).split(_pathSeparator);
    const prefixes = labels.map(item => URLVars.nodePath + _pathSeparator + item);
    const subBranchesNode = cutTree(filterDict(nodes, l2Visibility), prefixes);
    let newNodes = { ...subBranchesNode };
    newNodes[URLVars.nodePath!] = labels.filter(item => (l2Visibility[item] !== false));
    newNodes = replaceKeyPrefixes(newNodes, URLVars.nodePath!, "");
    const uniqueLabelsList = nodesToUniqueStrings(newNodes);
    const newL2Audio = cutTree(l2Audio, uniqueLabelsList);
    const newL2Image = cutTree(l2Image, uniqueLabelsList);
    const pecs = {
      'nodes': newNodes,
      'l2Audio': newL2Audio,
      'l2Image': newL2Image
    };
    const blob = dict2blob(pecs);
    let filename = inputFilename.current && typeof inputFilename.current.value === 'string' ? inputFilename.current.value : "0.pecs";
    downloadBlob(blob, filename);
  }

  /*
  function labelToCard(label: string, maxImgHeight:number, fontSize: number, invert: boolean = false): string {
    const imgStyle = `display: block; margin: auto; object-fit: contain; max-height:${maxImgHeight}px; `;
    const divStyle = `border: 1px solid gray; padding: 5px; text-align: center; display: flex; flex-direction: column; justify-content: center; align-items: center; border-radius:5px; width:100%`;
    const pStyle = `margin: 0; font-size: ${fontSize}px; align-self: center;`;
  
    const imgElement = `<img src='${l2Image[label]}' style='${imgStyle}' />`;
    const textElement = `<p style='${pStyle}'>${label2LabelToShow(label, lang, capitalizeText)}</p>`;
  
    return `
      <div style='${divStyle}'>
        ${invert ? imgElement + textElement : textElement + imgElement}
      </div>
    `;
  }
  
  
  
  
  function splitListIntoSubLists<T>(list: T[], maxElements:number): T[][] {
  let result: T[][] = [];
  for (let i = 0; i < list.length; i += maxElements) {
      let group: T[] = list.slice(i, i + maxElements);
      result.push(group);
  }
  return result;
  }
  
  function splitLongSublists(list: string[][], getCWFS: (s: string) => number, pageWidth: number): string[][] {
    let result: string[][] = [];
  
    for (let sublist of list) {
        let currentSublist: string[] = [], currentWidth = 0;
        for (let item of sublist) {
            let itemWidth = getCWFS(item);
            if (currentWidth + itemWidth > pageWidth) {
                if (currentSublist.length > 0) {
                    result.push(currentSublist);
                }
                currentSublist = [item];
                currentWidth = itemWidth;
            } else {
                currentSublist.push(item);
                currentWidth += itemWidth;
            }
        }
        if (currentSublist.length > 0) {
            result.push(currentSublist);
        }
    }
  
    return result;
  }
  */
  /*async function handleExportPDF() {
    setIsShareModalOpen(false);
    setExporting(false);
    setWaitTime(0);
    exportPDF("mainContentNoGrid");
    
  } */
  /*
  async function handlePDFExport() {
      function getBiggestElementHeight(className: string): number {
          let elements = document.getElementsByClassName(className);
          let maxHeight = 0;
  
          for (let i = 0; i < elements.length; i++) {
              let elementHeight = elements[i].clientHeight;
              if (elementHeight > maxHeight) {
                  maxHeight = elementHeight;
              }
          }
  
          return maxHeight;
      }
  
      const biggestH = getBiggestElementHeight('oneCard');
      
      const cardsHeight = biggestH < 170 ? 170 : biggestH > 500 ? 500 : biggestH;
  
      //const cardsHeight = 170*(cappedCardSizeMultiplied(cardSizeMultiplier));
      
      //const fontSize = 14;
      //const imageInCardsHeight = cardsHeight - fontSize - 5;
      const pagePadding = 10;
      const pageWidth = 794;
      const pageHeight = 1123;
      const longestWordLengthOverall = longestWordInList(visibleLabels || []);
      const getCWFS = (label:string) => { return calculateCardAndFontSize(cardSizeMultiplier, visibleLabels, _cardFontSizeMin, _cardFontSizeMax, _cardWidthMin, _cardWidthMax, label2LabelToShow(label, lang));};
      const getCW = (label:string) => { return getCWFS(label).CW; };
      const _SPECIAL_SEPARATOR = '0?1-Rr';
      let text = visibleLabels.join(_SPECIAL_SEPARATOR);
      let replacements: {[key: string] : string} = {
        "\n": " "
      };
      Object.keys(replacements).forEach(key => {
        text = text.split(key).join(replacements[key]);
      }); 
      let rows = text.split(_NEW_LINE).map((row) => row.split(_SPECIAL_SEPARATOR).filter((label) => label.trim() !== "").map((label) => charsMappingFromURL(label))).filter(elList => elList.length > 0); 
      rows = splitLongSublists(rows, getCW, pageWidth); 
      const rowsPerPage = Math.floor((pageHeight-2*pagePadding) / cardsHeight);
      //console.log("rowsPerPage",rowsPerPage, "cardsHeight", cardsHeight, "pageHeight", pageHeight)
      const pages = splitListIntoSubLists(rows, rowsPerPage);
      
      const pdf = new jsPDF({ orientation: 'p', unit: 'px', format: [pageWidth, pageHeight], hotfixes: ["px_scaling"], compress: true });
      const numberOfPages = pages.length;
      let x = pagePadding;
      let y = pagePadding;
    
      // Wrap the image loading in a new Promise
      const loadImage = (src: string) => {
        return new Promise((resolve, reject) => {
          const img = new Image();
          img.onload = () => resolve(img);
          img.onerror = reject;
          img.src = src;
        });
      };
  
  
      for (let pageIndex = 0; pageIndex < numberOfPages; pageIndex++) {
        const page = pages[pageIndex];
      
        const containerDiv = document.createElement('div');
        containerDiv.style.display = 'flex';
        containerDiv.style.flexWrap = 'wrap';
        containerDiv.style.flexDirection = 'column';
        containerDiv.style.width = `${pageWidth - 2 * pagePadding}px`;
        containerDiv.style.height = `${pageHeight - 2 * pagePadding}px`;
        //containerDiv.style.border = "1px red solid";
        for (const rows of page) {
          const row = document.createElement('div');
          row.style.display = 'flex';
          row.style.flexWrap = 'wrap';
          row.style.boxSizing = 'border-box'; // Set box-sizing to border-box for the row
          row.style.width = `${pageWidth - 2 * pagePadding}px`;
          row.style.margin = '0'; // Reset margin
      
          for (const label of rows) {
            const {CW:cardWidth, FS:fontSize} = getCWFS(label);
            const imageInCardsMaxHeight = cardsHeight - fontSize; // - 0.1*cardsHeight;
            const labelToCardElement = labelToCard(label, imageInCardsMaxHeight, fontSize, invertImgTxt);
            const cardDiv = document.createElement('div');
            cardDiv.innerHTML = labelToCardElement;
            cardDiv.style.display = 'flex';
            cardDiv.style.height = `${cardsHeight}px`;
            cardDiv.style.width = `${cardWidth}px`;
            cardDiv.style.boxSizing = 'border-box'; // Set box-sizing to border-box for the card
            cardDiv.style.margin = '0px'; // Reset margin
      
            row.appendChild(cardDiv.cloneNode(true));
          }
      
          containerDiv.appendChild(row.cloneNode(true));
        }
      
        document.body.appendChild(containerDiv);
      
        // Adjust pixel density for HTML to Canvas conversion
        const canvas: HTMLCanvasElement = await html2canvas(containerDiv, { scale: window.devicePixelRatio });
        const img = (await loadImage(canvas.toDataURL('image/png'))) as HTMLImageElement;  // Use the loadImage function here
        pdf.addImage(img.src, 'PNG', x, y, canvas.width / window.devicePixelRatio, canvas.height / window.devicePixelRatio);
          document.body.removeChild(containerDiv);
      
          if (pageIndex < numberOfPages - 1) {
            pdf.addPage();
          }
      }
      
      let filename = inputFilenamePDF.current && typeof inputFilenamePDF.current.value === 'string' ? inputFilenamePDF.current.value : "exported.pdf";
      pdf.save(filename);
      setExporting(false);
      setWaitTime(0);
  }
  */



  /*
  async function handlePDFExport() {
    const labels = visibleLabels;
    const scale = 0.5; // Fix the typo in the scale value
    const ratio = window.devicePixelRatio || 1;
  
    const pdf = new jsPDF('p', 'px', 'a4');
    const margin = 10;
    let y = margin;
    let x = margin;
    const _CARD_H = 150 * scale;
    const _PAGE_H = (pdf.internal.pageSize.getHeight() - 2 * margin) * scale;
    const _PAGE_W = (pdf.internal.pageSize.getWidth() - 2 * margin) * scale;
  
    // Calculate the number of cards that can fit in a row and on a page
    const rowsPerPage = Math.floor(_PAGE_H / _CARD_H);
  
    const widths = labels.map((label) => labelToWidth(label));
    const rows = groupStrings(labels, widthsToGroupSizes(widths, _PAGE_W));
    const rowsWithNoNewLine = rows.map((row) => row.filter((label) => label !== _NEW_LINE));
    const pages = splitListIntoSubLists(rowsWithNoNewLine, rowsPerPage);
  
    const numberOfPages = pages.length;
  
  
    for (let pageIndex = 0; pageIndex < numberOfPages; pageIndex++) {
      const page = pages[pageIndex];
  
      const grid = document.createElement('div');
      grid.style.display = 'flex';
      grid.style.flexWrap = 'wrap';
  
      for (const rows of page) {
        const row = document.createElement('div');
        row.style.display = 'flex';
        row.style.flexWrap = 'wrap';
  
        for (const label of rows) {
          const labelToCardElement = labelToCard(label);
          const cardDiv = document.createElement('div');
          cardDiv.innerHTML = labelToCardElement;
  
          cardDiv.style.height = `${_CARD_H}px`;
          cardDiv.style.width = `${labelToWidth(label)}px`;
  
          row.appendChild(cardDiv);
        }
  
        grid.appendChild(row.cloneNode(true));
      }
  
      document.body.appendChild(grid);
  
      const canvas: HTMLCanvasElement = await new Promise((resolve) => {
        html2canvas(grid, { scale: ratio }).then((result) => {
          resolve(result);
        });
      });
  
      pdf.addImage(canvas.toDataURL('image/png'), 'PNG', x, y, canvas.width / ratio, canvas.height / ratio);
  
      document.body.removeChild(grid);
  
      if (pageIndex < numberOfPages - 1) {
        pdf.addPage();
      }
  
      y += canvas.height / ratio + margin; // Add margin for the new page
    }
  
    pdf.save('labels.pdf');
    
    
  }*/







  return (
    <IonModal isOpen={isShareModalOpen} onDidDismiss={() => setIsShareModalOpen(false)}>
      <IonHeader>
        <IonToolbar>
          <IonTitle className='ion-text-center'>{_dict.shareBranchCards[lang]}</IonTitle>
        </IonToolbar>
      </IonHeader>
      <IonContent
        className="ion-text-center"
        style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'space-between' }}>

        <IonCard style={centeredIonCardStyle}>
          <IonCardHeader>
            <IonTitle>{_dict.fullSharing[lang]}</IonTitle>
          </IonCardHeader>
          <IonCardContent>

            <p>{_dict.includeSubBranchesAndImages[lang]}</p>
            <div>
              <IonInput
                value={data.split(_pathSeparator)[0].slice(0, 15) + "_" + data.length + ".pecs"}
                ref={inputFilename}
                style={{ width: "100%" }}>

              </IonInput>
              <div>
                <IonButton
                  onClick={handleExport}
                  style={{ ...baseBtnStyle, "--background": _defaultPurpleButtonColor }}>
                  <IonIcon icon={download} slot="start" size="large" />
                  {_dict.download[lang]}
                </IonButton>
              </div>
            </div>
          </IonCardContent>
        </IonCard>

        <IonCard style={{ ...centeredIonCardStyle }}>
          <IonCardHeader>
            <IonTitle>{_dict.minimalSharing[lang]}</IonTitle>
          </IonCardHeader>
          <IonCardContent>
            {data.length > _LIMIT_CHARS_URL_SHARE &&
              <p style={{ "color": "red" }}>
                {_dict.shareBranchCardsLimitExceededAlert[lang]}
              </p>}
            <p>{_dict.onlyCurrentBranchAndIgnoreImages[lang]}</p>
            {qrCodeURL && (
              <>
                <div>
                  <img src={qrCodeURL} alt="QR Code" style={{ height: '50%', width: 'auto', margin: 'auto' }} />
                  <p>
                    <a href={linkURL} onClick={(event) => {
                      event.preventDefault();
                      window.location.href = linkURL;
                    }}>
                      {linkURL.slice(0, 20)}...
                    </a>

                  </p>
                </div>
              </>
            )}
            <div>
              <IonButton
                id="open-toast"
                onClick={() => copyToClipboard(linkURL)}
                disabled={data.length > _LIMIT_CHARS_URL_SHARE}
                style={{ ...baseBtnStyle, "--background": "#007ea7" }}>
                <IonIcon icon={link} slot="start" size="large" />
                {_dict.copyLink[lang]}
              </IonButton>
            </div>
          </IonCardContent>
        </IonCard>

        <IonCard style={{ ...centeredIonCardStyle }}>
          <IonCardHeader>
            <IonTitle>{_dict.otherFormats[lang]}</IonTitle>
          </IonCardHeader>
          <IonCardContent>
            <IonButton
              size="large"
              color="light"
              onClick={() => {setShowPDFAlert(true);}}
              style={{ ...baseBtnStyle }}
            >
              <IonIcon icon={download} slot="start" size="large" />
              PDF
            </IonButton>



          </IonCardContent>
        </IonCard>

        <IonCard style={centeredIonCardStyle}>
          <IonCardHeader>
            <IonTitle>{_dict.goTo[lang]}</IonTitle>
          </IonCardHeader>
          <IonCardContent>
            <div>
              <IonButton
                color="success"
                style={{ ...baseBtnStyle, width: "100%", fontSize: "14px" }}
                onClick={() => {
                  copyToClipboard(linkURL);
                  logMe("click_community", { from: "shareModal" });
                  window.open(_dict.whatsApp[lang], "_blank");
                }} >
                <IonIcon slot="start" icon={logoWhatsapp} size="large" />
                Community
              </IonButton>
            </div>
            <div >
              <IonButton
                onClick={() => setIsShareModalOpen(false)}
                style={{ ...baseBtnStyle, width: "100%", "--background": "#cf3c4f" }}>
                <IonIcon icon={closeCircle} slot="end" size="large" />
                {_dict.dismissToast[lang]}
              </IonButton>
            </div>
          </IonCardContent>
        </IonCard>



        <IonToast color="light"
          trigger="open-toast"
          style={{ textAlign: "center", fontSize: "16px" }}
          message={_dict.linkCopied[lang]} duration={1000} position='top'></IonToast>
        <IonAlert isOpen={showPDFAlert} onDidDismiss={() => setShowPDFAlert(false)}
          header={_dict.exportPDF[lang]}
          message={_dict.exportPDFAlert[lang]}
          buttons={[{
            text: _dict.ok[lang],
            role: 'cancel',
            cssClass: 'secondary'
          }]}
        />
      </IonContent>

    </IonModal>
  );
};

export default ShareModal;
